module.exports = __webpack_public_path__ + "img/emptycart.86c01149.svg";